module.exports = __webpack_public_path__ + "static/media/coco_bambino_thumb.61b91d53.jpg";